<template>

  <t-page>


    <t-page-list :title="currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">



      <template #search>


        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'" primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>

      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="ui.formatZeroNumber(item.productionBulkActionNumber,4)" :userAuth="userAuth" :id="item.productionBulkActionNumber"
                               :path="currentPage.path"/>
        </template>

        <template #cell(generalStartDate)="{item}">
          {{item.generalStartDate | datetime}}
        </template>

        <template #cell(generalFinishDate)="{item}">
          {{item.generalFinishDate | datetime}}
        </template>

        <template #cell(qtyErrors)="{item}">
          <span v-if="item.qtyErrors > 0" class="text-danger">{{item.qtyErrors}}</span>
          <span v-else>{{item.qtyErrors}}</span>
        </template>

        <template #cell(qtyTotal)="{item}">
          {{item.qtyProcessed}} / {{item.qtyValidated}}
        </template>
        
        <template #cell(actions)="{item}">
          <t-list-actions-default :disable-delete="item.statusBulkAction === StatusBulkActionType.type.PROCESSED" :form-path="currentPage.path" :id="item.productionBulkActionNumber" :userAuth="userAuth"/>
        </template>

        <template #cell(statusBulkAction)="{item}">
          <t-bulk-status-badge :status="item.statusBulkAction" />
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import ui from "@/assets/scripts/ui";
import tBulkStatusBadge from "@/components/template/theme/t-bulk-status-badge";
import StatusBulkActionType from "@/model/types/resource/StatusBulkActionType";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {tBulkStatusBadge},
  name: 'ProductionOrderBulkAction',
  data() {
    return {
      ui,
      path: "", //Utilizar somente quando fora do padrão
      StatusBulkActionType,
      fields: [
        {key: "first", label: "Nº Ação"},
        {key: "generalStartDate", label: "Início Processamento", formatter:"datetime"},
        {key: "generalFinishDate", label: "Término Processamento", formatter:"datetime"},
        {key: "qtyErrors", label: "Qtd. Erros", cols: "2"},
        {key: "qtyTotal", label: "Qtd. Processado/Qtd. Total"},
        {key: "statusBulkAction", label: "Status Processamento", cols: "2"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
